export const MAX_PAGE_WIDTH = 'max-w-6xl';
